import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { api, ApiError, sessionStore, tokenStore } from "../lib/api";

// Attendee entry. The QR code generator on OrgDashboard embeds ?code=ABC123
// so a phone scan deep-links the input pre-filled.
export default function Join() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [code, setCode] = useState(params.get("code") ?? "");
  const [name, setName] = useState("");
  const [anonymous, setAnonymous] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      const finalName = anonymous ? null : name.trim() || null;
      const r = await api.joinByCode(code.trim().toUpperCase(), {
        display_name: finalName,
        is_anonymous: anonymous,
      });
      tokenStore.set(r.token);
      sessionStore.set({
        id: r.session_id,
        name: r.session_name,
        state: r.session_state,
        participantId: r.participant_id,
        displayName: finalName,
        isAnonymous: anonymous,
      });
      nav(`/sessions/${r.session_id}/board`);
    } catch (e) {
      setErr(e instanceof ApiError ? e.message : "could not join");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main>
      <div className="reading">
      <h1>Join an event</h1>
      <p style={{ color: "var(--fg-muted)" }}>
        Enter the code shown on screen, or scan the QR.
      </p>
      <form onSubmit={submit}>
        <label htmlFor="code">Event code</label>
        <input
          id="code"
          type="text"
          autoCapitalize="characters"
          autoCorrect="off"
          spellCheck={false}
          value={code}
          onChange={(e) => setCode(e.target.value)}
          required
          maxLength={16}
          aria-required="true"
        />

        <label htmlFor="name" style={{ marginTop: "1rem", display: "block" }}>
          Your name (optional)
        </label>
        <input
          id="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          disabled={anonymous}
          maxLength={128}
        />

        <label className="row" style={{ marginTop: "0.75rem" }}>
          <input
            type="checkbox"
            checked={anonymous}
            onChange={(e) => setAnonymous(e.target.checked)}
          />
          <span>Join anonymously</span>
        </label>

        {err && <p className="error" role="alert">{err}</p>}

        <button type="submit" disabled={busy || !code.trim()} style={{ marginTop: "1rem", width: "100%" }}>
          {busy ? "Joining…" : "Join"}
        </button>
      </form>
      </div>
    </main>
  );
}
